import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import StepConfigEditorRouterV2 from 'pipelines/generalized-step-config-editor/editors/StepConfigEditorRouterV2';
import {StepConfigEditorContext} from 'pipelines/generalized-step-config-editor/StepConfigEditorContext';
import {JSONValue} from 'util/Types';

import {useDataLayoutContext} from './DataLayoutContext';
import {
  ConfigFormBlock as ConfigFormBlockType,
  ConfigFormField as ConfigFormFieldType,
} from './DataLayoutTypes';

interface ConfigFormFieldProps {
  configFormField: ConfigFormFieldType;
}

export function ConfigFormField({
  configFormField: {configDataFrameSpec, ...stepConfigEditorRouterV2Props},
}: ConfigFormFieldProps): JSX.Element {
  const {clientId} = useDataLayoutContext();

  const contextValue = useMemo(
    () => ({dataFrameSpec: configDataFrameSpec, clientStateId: clientId}),
    [configDataFrameSpec, clientId]
  );

  return (
    <StepConfigEditorContext.Provider value={contextValue}>
      <StepConfigEditorRouterV2
        {...stepConfigEditorRouterV2Props}
        onChangeConfig={(config: JSONValue, path: Array<string>, newValue: JSONValue) => {
          // TODO(BNCH-128478): Implement update config callback
        }}
      />
    </StepConfigEditorContext.Provider>
  );
}
interface ConfigFormBlockProps {
  block: ConfigFormBlockType;
}

export default function ConfigFormBlock({block: {configFields}}: ConfigFormBlockProps): JSX.Element {
  return (
    <div className={css(styles.configFormBlockContainer)}>
      {configFields.map((configFormField, index) => (
        <ConfigFormField key={index} configFormField={configFormField} />
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  configFormBlockContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
